import AlterarSenhaHash from '@/templates/Auth/modals/AlterarSenhaHash'
import ConfirmarEmail from '@/templates/Auth/modals/ConfirmarEmail'
import AlterarPlano from '@/templates/Checkout/AlterarPlano'
import MinhaAssinatura from '@/templates/Planos/MinhaAssinatura/index'
import AlterarMetodoPagamento from '@/templates/Planos/modals/AlterarMetodoPagamento'
import CancelarAssinatura from '@/templates/Planos/modals/CancelarAssinaturaModal'
import BaterPonto from 'pages/BaterPonto'
import React from 'react'
import { Route, RouteObject, Routes } from 'react-router-dom'
import DetalhesAlteracao from 'templates/Alteracoes/Detalhes'
import RecuperarSenha from 'templates/Auth/modals/RecuperarSenha'
import { FormularioAvaliacao } from 'templates/Avaliacao'
import { Planos } from 'templates/Planos'
import { Login } from '../pages/Auth'
import { NotFound } from '../templates/NotFound'
import paths from './paths'
import { Preload } from './preload'
import { PrivateRoutes } from './private'
import { PublicRoutes } from './public'

const PlanosPage = React.lazy(() => import('pages/Planos'))
const EscolherFuncionario = React.lazy(
    () => import('pages/EscolherFuncionario'),
)
const Perfil = React.lazy(() => import('pages/Perfil'))
const Alteracoes = React.lazy(() => import('pages/Alteracoes'))
const Checkout = React.lazy(() => import('@/templates/Checkout/Checkout'))
const Dashboard = React.lazy(() => import('pages/Dashboard'))
const Success = React.lazy(() => import('pages/Success'))

export default function Router() {
    return (
        <Preload>
            <Routes>
                <Route element={<PrivateRoutes />}>
                    {paths.map(render)}
                    <Route path="/planos" element={<PlanosPage />}>
                        <Route index path="/planos" element={<Planos />} />
                        <Route path="/planos/checkout" element={<Checkout />} />
                        <Route
                            path="/planos/alterar"
                            element={<AlterarPlano />}
                        />
                        <Route path="/planos/me" element={<MinhaAssinatura />}>
                            <Route
                                path="/planos/me/cobranca/:id/cancelar"
                                element={<CancelarAssinatura />}
                            />
                            <Route
                                path="/planos/me/cobranca/:id/cartao"
                                element={<AlterarMetodoPagamento />}
                            />
                        </Route>
                    </Route>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/success" element={<Success />} />
                    <Route
                        path="/selecionar-funcionario"
                        element={<EscolherFuncionario />}
                    />
                    <Route path="/perfil" element={<Perfil />} />
                    <Route path="/alteracoes" element={<Alteracoes />}>
                        <Route
                            path="/alteracoes/diff/:id"
                            element={<DetalhesAlteracao />}
                        />
                    </Route>
                    <Route path="*" element={<NotFound />} />
                </Route>

                <Route element={<PublicRoutes />}>
                    <Route path="/" element={<Login />}>
                        <Route
                            path="recuperar-senha"
                            element={<RecuperarSenha />}
                        />
                        <Route
                            path="alterar-senha"
                            element={<AlterarSenhaHash />}
                        />
                        <Route
                            path="confirmar-email"
                            element={<ConfirmarEmail />}
                        />
                        <Route
                            path="avaliacao"
                            element={<FormularioAvaliacao />}
                        />
                        <Route path="checkout" element={<Checkout />} />
                    </Route>
                    <Route path="/bater-ponto" element={<BaterPonto />} />
                </Route>
            </Routes>
        </Preload>
    )
}

function render(elm: RouteObject): JSX.Element[] {
    if (elm.children) {
        const indexChildren = elm.children.filter(it => it.index),
            restChildren = elm.children.filter(it => !it.index)
        return [
            <Route key={elm.path} path={elm.path} element={elm.element}>
                {restChildren.map(render)}
            </Route>,
            ...indexChildren.flatMap(render),
        ]
    }
    return [<Route key={elm.path} path={elm.path} element={elm.element} />]
}
